"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _FinProSimpleSearch = require("../FinProSimpleSearch");
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _axios = _interopRequireDefault(require("axios"));
var _AgentSearchList = _interopRequireDefault(require("../../components/finpro/AgentSearchList"));
var _AgencySearchList = _interopRequireDefault(require("../../components/finpro/AgencySearchList"));
var _generatePayload = _interopRequireDefault(require("./generatePayload"));
var _PaginationControls = _interopRequireDefault(require("./PaginationControls"));
var _ResultNotFound = _interopRequireDefault(require("../../components/finpro/ResultNotFound"));
var _defaultSearchState = _interopRequireDefault(require("../FinProSimpleSearch/defaultSearchState"));
var _MultiplePinMap = require("../../components/finpro/maps/MultiplePinMap");
var _richTextField = require("../../lib/richTextField");
var _Popup = _interopRequireDefault(require("../CCPAForm/Common/Popup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DISTANCEKEY = {
  0: 1,
  1: 5,
  2: 10,
  3: 20,
  4: 50,
  5: 3000
};
function FinProSearch(props) {
  var {
    disclaimer
  } = props.pageprops;
  var formData = props.formParams;
  var [searchState, setSearchState] = (0, _react.useState)({
    finProOrAgencySelection: '',
    nameOrZipCodeInputSelection: '',
    searchByName: false,
    languageOptions: [],
    specialtyOptions: [],
    specialtySelection: [],
    languageSelection: [],
    distanceFilterSelection: 'Distance: Within 5 Miles',
    distanceFilterSelectionIndex: 1,
    distanceMiles: 5,
    hasCalledForInitialData: false
  });
  var [searchTrigger, setSearchTrigger] = (0, _react.useState)(0);
  var [isFirstRender, setIsFirstRender] = (0, _react.useState)(true);
  var [shouldNotTriggerAutocomplete, setShouldNotTriggerAutocomplete] = (0, _react.useState)(true);
  var [apiData, setApiData] = (0, _react.useState)('');
  var [isLoading, setIsLoading] = (0, _react.useState)(true);
  var [initialApiDataIsSet, updateInitialApiDataIsSet] = (0, _react.useState)(false);
  var [mapData, setMapData] = (0, _react.useState)([]);
  var [hoverId, setHoverId] = (0, _react.useState)('');
  var [googleApiIsLoaded, setGoogleApiIsLoaded] = (0, _react.useState)(false);
  var [showResetFilters, setShowResetFilters] = (0, _react.useState)(false);
  var [showMapPopup, setShowMapPopup] = (0, _react.useState)(false);
  var requestIndex = (0, _react.useRef)(0);
  (0, _react.useEffect)(() => {
    // Window object is not available on first render
    if (isFirstRender) {
      setIsFirstRender(false);
      return;
    }
    // Once we have window object, we will pull data from previous page and
    if (typeof window !== 'undefined') {
      if (!(0, _lodash.isEmpty)(JSON.parse(localStorage.getItem('searchData')))) {
        var searchData = JSON.parse(localStorage.getItem('searchData'));
        localStorage.setItem('searchData', JSON.stringify({}));
        setSearchState(prevState => {
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), searchData), {}, {
            initialSearchDataIsSet: true
          });
        });
      } else {
        // Use default search state if no data is found in local storage
        setSearchState(prevState => {
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), _defaultSearchState.default), {}, {
            initialSearchDataIsSet: true
          });
        });
      }
    }
  }, [isFirstRender]);
  (0, _react.useEffect)(() => {
    // When the search state changes for the fist time as a result of pulling the local storage data
    // We want to trigger the initial API call one time by upping the count on searchTrigger
    // We also want to enable auto complete after the page has loaded

    if (searchState.finProOrAgencySelection && !searchState.hasCalledForInitialData) {
      setSearchTrigger(searchTrigger + 1);
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          hasCalledForInitialData: true
        });
      });
      setShouldNotTriggerAutocomplete(false);
    }
  }, [searchState]);
  (0, _react.useEffect)(() => {
    // If searching for blank name, we should not trigger API search call
    // Or if searching for a location which we could not find with google places api, we should not trigger API search call
    if (searchTrigger && searchState.searchByName && searchState.nameOrZipCodeInputSelection === '' || searchTrigger && !searchState.searchByName && !searchState.lat) {
      setApiData([]);
      setIsLoading(false);
      sendTealiumEvent(searchState, null);
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          languageSelection: [],
          specialtySelection: [],
          distanceMiles: 5,
          distanceFilterSelectionIndex: 1
        });
      });
      setShowResetFilters(false);
    } else if (searchTrigger) {
      var thisEffectsRequestIndex = requestIndex.current + 1;
      requestIndex.current = thisEffectsRequestIndex;
      function fetchAgentData() {
        return _fetchAgentData.apply(this, arguments);
      }
      function _fetchAgentData() {
        _fetchAgentData = _asyncToGenerator(function* () {
          try {
            setIsLoading(true);
            var agentOrAgency = searchState.finProOrAgencySelection === 'Financial Professional' ? 'agent' : 'agency';
            var result = yield _axios.default.post("/apicalls/finpro/search/".concat(agentOrAgency), (0, _generatePayload.default)(agentOrAgency, searchState));
            // The requestIndex is used to ensure that the data we are setting is the most recent
            // and that if multiple useEffects are queued in small amoutn of time, we only set the results of the
            // most recent one
            if (thisEffectsRequestIndex === requestIndex.current) {
              // Reset disableNextAvailableDistSearch
              // Reset upperlat and upperlng, which will only be set after someone researches from map
              setSearchState(prevState => {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  disableNextAvailableDistSearch: false,
                  upperlat: '',
                  upperlng: '',
                  isRedoSearch: false,
                  hideDistanceFilter: searchState.isRedoSearch
                });
              });
              setApiData(result);
              sendTealiumEvent(searchState, result);
              setIsLoading(false);
            }
          } catch (err) {
            // stop loading and show error
            setIsLoading(false);
            console.error(err);
          }
        });
        return _fetchAgentData.apply(this, arguments);
      }
      fetchAgentData();
      // Determine if a search was made with filters, if so update state so we can track this and render reset button
      var filtersAreApplied = !!(searchState.languageSelection.length > 0 || searchState.specialtySelection.length > 0);
      setShowResetFilters(filtersAreApplied);
      // save previous filter selections to searchState
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          lastFiltersUsed: {
            languageSelection: prevState.languageSelection,
            specialtySelection: prevState.specialtySelection
          }
        });
      });
    }
  }, [searchTrigger]);
  (0, _react.useEffect)(() => {
    var _apiData$data;
    // Need to filter out no longer existing langauges and specialies that were previously selected in filters
    // but don't exist in new search results
    if (apiData !== null && apiData !== void 0 && (_apiData$data = apiData.data) !== null && _apiData$data !== void 0 && (_apiData$data = _apiData$data.data) !== null && _apiData$data !== void 0 && _apiData$data.hits) {
      var _apiData$data4, _apiData$data5;
      if (searchState.languageSelection) {
        var newLanguageSelection = [];
        // iterate through previous langauge selections
        searchState.languageSelection.forEach(languageObject => {
          var _apiData$data2;
          // if language still exists in results, push to newLanguageSelections
          if (apiData !== null && apiData !== void 0 && (_apiData$data2 = apiData.data) !== null && _apiData$data2 !== void 0 && (_apiData$data2 = _apiData$data2.data) !== null && _apiData$data2 !== void 0 && _apiData$data2.languagefacet.some(e => e.key === languageObject.label)) {
            newLanguageSelection.push(languageObject);
          }
          setSearchState(prevValue => {
            return _objectSpread(_objectSpread({}, prevValue), {}, {
              languageSelection: newLanguageSelection
            });
          });
        });
      }
      if (searchState.specialtySelection) {
        var newspecialtySelection = [];
        // iterate through previous specialty selections
        searchState.specialtySelection.forEach(specialtyObject => {
          var _apiData$data3;
          // if specialty still exists in results, push to newSpecialtySelections
          if (apiData !== null && apiData !== void 0 && (_apiData$data3 = apiData.data) !== null && _apiData$data3 !== void 0 && (_apiData$data3 = _apiData$data3.data) !== null && _apiData$data3 !== void 0 && _apiData$data3.specialtyfacet.some(e => e.key === specialtyObject.label)) {
            newspecialtySelection.push(specialtyObject);
          }
          setSearchState(prevValue => {
            return _objectSpread(_objectSpread({}, prevValue), {}, {
              specialtySelection: newspecialtySelection
            });
          });
        });
      }
      // If results returned a distanceFacet that does not match our current distanceMiles
      // we should update our distanceMiles and distanceFilterSelectionIndex with the new values
      if (apiData !== null && apiData !== void 0 && (_apiData$data4 = apiData.data) !== null && _apiData$data4 !== void 0 && (_apiData$data4 = _apiData$data4.data) !== null && _apiData$data4 !== void 0 && _apiData$data4.distkeyselected && (apiData === null || apiData === void 0 || (_apiData$data5 = apiData.data) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.data) === null || _apiData$data5 === void 0 ? void 0 : _apiData$data5.distkeyselected) !== "d".concat(searchState.distanceMiles)) {
        var _apiData$data6;
        var newDistanceMiles = apiData === null || apiData === void 0 || (_apiData$data6 = apiData.data) === null || _apiData$data6 === void 0 || (_apiData$data6 = _apiData$data6.data) === null || _apiData$data6 === void 0 ? void 0 : _apiData$data6.distkeyselected.replace('d', '');
        var newDistanceFilterSelectionIndex = Object.keys(DISTANCEKEY).find(key => DISTANCEKEY[key] === parseInt(newDistanceMiles));
        setSearchState(prevValue => {
          return _objectSpread(_objectSpread({}, prevValue), {}, {
            distanceMiles: newDistanceMiles,
            distanceFilterSelectionIndex: newDistanceFilterSelectionIndex
          });
        });
      }
      // Everytime we get new search results we want to format the data for the map
      if (searchState.finProOrAgencySelection === 'Financial Professional') {
        var _apiData$data7;
        var newMapData = [];
        var agencyTempKey = {};
        // Construct an object with unique agency ids as keys and the agency data as values
        // This will let us count the number of agents per agency
        apiData === null || apiData === void 0 || (_apiData$data7 = apiData.data) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7.data) === null || _apiData$data7 === void 0 || _apiData$data7.hits.forEach(agent => {
          var uniqueId = agent.agency.coreagencynumber;
          if (agent.agency.subagencynumber) uniqueId += '-' + agent.agency.subagencynumber;
          if (!agencyTempKey[uniqueId]) {
            agencyTempKey[uniqueId] = {
              count: 1,
              agencyName: agent.agency.agencyname,
              agencyUrl: agent.agency.agencyurl,
              officeType: agent.agency.officetype,
              coreagencynumber: agent.agency.coreagencynumber,
              subagencynumber: agent.agency.subagencynumber,
              location: {
                addressLine: agent.agency.location.addressline,
                addressLinesExtra: agent.agency.location.addresslinesextra,
                city: agent.agency.location.city,
                latitude: agent.agency.location.latitude,
                longitude: agent.agency.location.longitude,
                phone: agent.agency.location.phone,
                state: agent.agency.location.state,
                zip: agent.agency.location.zip
              }
            };
          } else {
            agencyTempKey[uniqueId].count++;
          }
        });
        // Construct an array of agencies from the object we just created
        for (var [key, value] of Object.entries(agencyTempKey)) {
          newMapData.push(_objectSpread({}, value));
        }
        // Construct agency key based on array we just created, this will let use identify the index of an agency by its unique id
        // This will be used in setHoverId for agent scenario
        var agencyKey = {};
        newMapData.forEach((agency, index) => {
          var uniqueId = agency.coreagencynumber;
          if (agency.subagencynumber) uniqueId += '-' + agency.subagencynumber;
          agencyKey[uniqueId] = index;
        });
        setMapData({
          agencyData: newMapData,
          agencyKey
        });
      } else {
        var _apiData$data8;
        var agencyFormattedData = apiData === null || apiData === void 0 || (_apiData$data8 = apiData.data) === null || _apiData$data8 === void 0 || (_apiData$data8 = _apiData$data8.data) === null || _apiData$data8 === void 0 ? void 0 : _apiData$data8.hits.map(agency => {
          return {
            agencyName: agency.agencyname,
            agencyUrl: agency.agencyurl,
            location: {
              addressLine: agency.location.addressline,
              addressLinesExtra: agency.location.addresslinesextra,
              city: agency.location.city,
              latitude: agency.location.latitude,
              longitude: agency.location.longitude,
              phone: agency.location.phone,
              state: agency.location.state,
              zip: agency.location.zip
            }
          };
        });
        setMapData({
          agencyData: agencyFormattedData,
          agencyKey: {}
        });
      }
    } else {
      setMapData({
        agencyData: [],
        agencyKey: {}
      });
    }
    if (searchTrigger && !initialApiDataIsSet) {
      updateInitialApiDataIsSet(true);
    }
  }, [apiData]);
  function _onSearch() {
    setSearchTrigger(searchTrigger + 1);
  }
  function redoSearchOnClick(bounds) {
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        upperlat: bounds.north,
        upperlng: bounds.east,
        lat: bounds.south,
        lng: bounds.west,
        isRedoSearch: true
      });
    });
    _onSearch();
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container",
    role: "main"
  }, searchState.initialSearchDataIsSet && searchState.languageOptions ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FinProSimpleSearch.FinProSimpleSearchCard, {
    onSearch: optionalSearchTerm => _onSearch(optionalSearchTerm),
    className: "mm-desktop-only",
    searchState: searchState,
    setSearchState: setSearchState,
    setApiData: setApiData,
    setIsLoading: setIsLoading,
    shouldNotTriggerAutocomplete: shouldNotTriggerAutocomplete,
    setGoogleApiIsLoaded: setGoogleApiIsLoaded
  }), /*#__PURE__*/_react.default.createElement(_FinProSimpleSearch.FinProSimpleSearchCard, {
    onSearch: optionalSearchTerm => _onSearch(optionalSearchTerm),
    className: "mm-tablet-mobile-only",
    searchState: searchState,
    setSearchState: setSearchState,
    setApiData: setApiData,
    setIsLoading: setIsLoading,
    shouldNotTriggerAutocomplete: shouldNotTriggerAutocomplete,
    setGoogleApiIsLoaded: setGoogleApiIsLoaded
  })) : undefined, /*#__PURE__*/_react.default.createElement(FilterAndResults, {
    searchState: searchState,
    setSearchState: setSearchState,
    apiData: apiData,
    isLoading: isLoading,
    onSearch: _onSearch,
    mapData: mapData,
    hoverId: hoverId,
    setHoverId: setHoverId,
    disclaimer: disclaimer,
    formData: formData,
    googleApiIsLoaded: googleApiIsLoaded,
    initialApiDataIsSet: initialApiDataIsSet,
    showResetFilters: showResetFilters,
    setShowMapPopup: setShowMapPopup,
    redoSearchOnClick: redoSearchOnClick
  }), /*#__PURE__*/_react.default.createElement(_Popup.default, {
    show: showMapPopup,
    handleClose: () => setShowMapPopup(false),
    title: "Map",
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: "map-col popup-map-col"
    }, /*#__PURE__*/_react.default.createElement(_MultiplePinMap.MultiplePinMap, {
      agencyList: mapData.agencyData,
      hoverId: hoverId,
      setHoverId: setHoverId,
      redoSearchOnClick: redoSearchOnClick
    }))
  }));
}
function FilterAndResults(_ref) {
  var {
    searchState,
    setSearchState,
    apiData,
    isLoading,
    onSearch,
    mapData,
    hoverId,
    setHoverId,
    disclaimer,
    formData,
    googleApiIsLoaded,
    initialApiDataIsSet,
    showResetFilters,
    setShowMapPopup,
    redoSearchOnClick
  } = _ref;
  var [currentPage, setCurrentPage] = (0, _react.useState)(1);
  var [totalPages, setTotalPages] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    var _apiData$data9;
    if (apiData !== null && apiData !== void 0 && (_apiData$data9 = apiData.data) !== null && _apiData$data9 !== void 0 && (_apiData$data9 = _apiData$data9.data) !== null && _apiData$data9 !== void 0 && _apiData$data9.hits) {
      var _apiData$data10;
      setTotalPages(Math.ceil((apiData === null || apiData === void 0 || (_apiData$data10 = apiData.data) === null || _apiData$data10 === void 0 || (_apiData$data10 = _apiData$data10.data) === null || _apiData$data10 === void 0 ? void 0 : _apiData$data10.totalitems) / 10));
      setCurrentPage(1);
    } else {
      setTotalPages(0);
      setCurrentPage(1);
    }
  }, [apiData]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "search-filter-container"
  }, isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "filters-loading"
  }) : /*#__PURE__*/_react.default.createElement(Filters, {
    searchState: searchState,
    setSearchState: setSearchState,
    apiData: apiData,
    onSearch: onSearch,
    showResetFilters: showResetFilters,
    setShowMapPopup: setShowMapPopup
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "finpro-search-results-row ".concat(isLoading ? 'loading' : '')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 8,
    md: 12,
    sm: 12,
    className: "results-col"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(Loading, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Results, {
    currentPage: currentPage,
    apiData: apiData,
    finProOrAgencySelection: searchState.finProOrAgencySelection,
    lastSearchedTerm: searchState.lastSearchedTerm,
    setHoverId: setHoverId,
    agencyKey: mapData.agencyKey,
    formData: formData
  }), /*#__PURE__*/_react.default.createElement(_PaginationControls.default, {
    totalPages: totalPages,
    currentPage: currentPage,
    setCurrentPage: setCurrentPage
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "disclaimer"
  }, (0, _richTextField.parseHTML)(disclaimer)))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    className: "mm-desktop-only map-col"
  }, googleApiIsLoaded && initialApiDataIsSet ? /*#__PURE__*/_react.default.createElement(_MultiplePinMap.MultiplePinMap, {
    agencyList: mapData.agencyData,
    hoverId: hoverId,
    setHoverId: setHoverId,
    redoSearchOnClick: redoSearchOnClick
  }) : null)));
}
function Results(_ref2) {
  var _apiData$data11;
  var {
    currentPage,
    apiData,
    finProOrAgencySelection,
    lastSearchedTerm,
    setHoverId,
    agencyKey,
    formData
  } = _ref2;
  if (!(apiData !== null && apiData !== void 0 && (_apiData$data11 = apiData.data) !== null && _apiData$data11 !== void 0 && (_apiData$data11 = _apiData$data11.data) !== null && _apiData$data11 !== void 0 && _apiData$data11.hits)) {
    return /*#__PURE__*/_react.default.createElement(_ResultNotFound.default, {
      noResultMessage: "<span>No results found for <strong>".concat(lastSearchedTerm ? lastSearchedTerm : '""', "</strong></span>")
    });
  } else if (finProOrAgencySelection === 'Financial Professional') {
    var _apiData$data12;
    return /*#__PURE__*/_react.default.createElement(_AgentSearchList.default, {
      currentPage: currentPage,
      agents: apiData === null || apiData === void 0 || (_apiData$data12 = apiData.data) === null || _apiData$data12 === void 0 || (_apiData$data12 = _apiData$data12.data) === null || _apiData$data12 === void 0 ? void 0 : _apiData$data12.hits,
      setHoverId: setHoverId,
      agencyKey: agencyKey,
      formData: formData
    });
  } else {
    var _apiData$data13;
    return /*#__PURE__*/_react.default.createElement(_AgencySearchList.default, {
      currentPage: currentPage,
      agencies: apiData === null || apiData === void 0 || (_apiData$data13 = apiData.data) === null || _apiData$data13 === void 0 || (_apiData$data13 = _apiData$data13.data) === null || _apiData$data13 === void 0 ? void 0 : _apiData$data13.hits,
      setHoverId: setHoverId,
      agencyKey: agencyKey
    });
  }
}
function DistanceFilterDropdown(_ref3) {
  var _apiData$data14, _apiData$data15;
  var {
    searchState,
    setSearchState,
    apiData,
    onSearch
  } = _ref3;
  if (!(apiData !== null && apiData !== void 0 && (_apiData$data14 = apiData.data) !== null && _apiData$data14 !== void 0 && (_apiData$data14 = _apiData$data14.data) !== null && _apiData$data14 !== void 0 && _apiData$data14.distancefacet)) return '';

  // Handle special situation where we are returning results 3000+ miles away
  // When constructing the label, add a plus sign in only 3000+ case
  var endIndex = searchState.distanceMiles === '3000' ? 6 : 5;
  var distanceFilterOptions = apiData === null || apiData === void 0 || (_apiData$data15 = apiData.data) === null || _apiData$data15 === void 0 || (_apiData$data15 = _apiData$data15.data) === null || _apiData$data15 === void 0 || (_apiData$data15 = _apiData$data15.distancefacet) === null || _apiData$data15 === void 0 ? void 0 : _apiData$data15.slice(0, endIndex).map((option, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Distance: Within ".concat(DISTANCEKEY[index] === 3000 ? '50+' : DISTANCEKEY[index], " miles "), /*#__PURE__*/_react.default.createElement("span", {
      className: "copy-sm"
    }, " (".concat(option.doc_count, ")")));
  });
  var label = distanceFilterOptions ? "Distance: Within ".concat(searchState.distanceMiles === '3000' ? '50+' : searchState.distanceMiles, " Miles") : 'Distance: Within 5 Miles';
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown, {
    id: "finpro-or-agency",
    className: "form-group right-align-dropdown"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Toggle, {
    id: "new_dropdown0_toggle",
    label: label,
    "aria-label": "".concat(label ? label + ', selected' : ''),
    type: 'default'
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Menu, {
    id: "finpro-or-agency-menu"
  }, distanceFilterOptions.map((option, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.DefaultItem, {
      key: index,
      onClick: () => {
        setSearchState(prevState => {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            distanceFilterSelectionIndex: index,
            distanceMiles: DISTANCEKEY[index],
            disableNextAvailableDistSearch: true
          });
        });
        onSearch();
      }
    }, option);
  })));
}
function ChecklistDropdown(props) {
  var _apiData$data16, _apiData$data17, _searchState$lastFilt3;
  var {
    searchState,
    setSearchState,
    type,
    apiData
  } = props;
  if (!(apiData !== null && apiData !== void 0 && (_apiData$data16 = apiData.data) !== null && _apiData$data16 !== void 0 && (_apiData$data16 = _apiData$data16.data) !== null && _apiData$data16 !== void 0 && _apiData$data16["".concat(type, "facet")])) return '';
  var [showDropdown, setShowDropdown] = (0, _react.useState)(false);
  var [label, setLabel] = (0, _react.useState)(props.defaultLabel);
  var [selected, setSelected] = (0, _react.useState)(false);
  var [keyPrefix, setKeyPrefix] = (0, _react.useState)(Date.now());
  var searchResults = apiData === null || apiData === void 0 || (_apiData$data17 = apiData.data) === null || _apiData$data17 === void 0 ? void 0 : _apiData$data17.data;
  var capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
  var pluralFormOfType = capitalizedType === 'Specialty' ? 'Specialties' : capitalizedType + 's';
  var [isMounted, setIsMounted] = (0, _react.useState)(false);

  // Set
  (0, _react.useEffect)(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  // Set selected to true if there are any items in the selection array
  (0, _react.useEffect)(() => {
    setSelected(searchState["".concat(type, "Selection")].length > 0);
    if (searchState["".concat(type, "Selection")].length > 0) {
      updateLabel();
    }
  }, []);
  var updateLabel = () => {
    if (searchState["".concat(type, "Selection")].length > 0) {
      setLabel(searchState["".concat(type, "Selection")].length == 1 ? "1 ".concat(capitalizedType) : "".concat(searchState["".concat(type, "Selection")].length, " ").concat(pluralFormOfType));
    } else {
      setLabel(props.defaultLabel);
    }
  };

  // Run fucntion when ever showDropdown is changed to false, which is when the dropdown is closed
  (0, _react.useEffect)(() => {
    if (!showDropdown) searchIfFiltersAreUpdated();
  }, [showDropdown]);

  // Handle 'click' events on the Dropdown toggle.
  var toggleHandler = () => {
    setSelected(searchState["".concat(type, "Selection")].length > 0);
    setShowDropdown(!showDropdown);
  };

  // Handle 'click' events on the Apply Button.
  // Here we will update the state, which will trigger a useEffect, which recalls API data or simply filters results
  var applyHandler = e => {
    setSelected(searchState["".concat(type, "Selection")].length > 0);
    setShowDropdown(false);
    if (props.applyOnClick) props.applyOnClick(e);
  };

  // Handle 'click' events on the Dropdown items.
  var clickHandler = (e, _ref4) => {
    var {
      id,
      label
    } = _ref4;
    var newSelection = [];
    if (e.target.checked) {
      newSelection = [...searchState["".concat(type, "Selection")]];
      newSelection.push({
        id,
        label
      });
    } else {
      newSelection = searchState["".concat(type, "Selection")].filter(item => item.id != id);
    }
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        ["".concat(type, "Selection")]: newSelection
      });
    });
    var numChecked = newSelection.length;
    setLabel(numChecked === 0 ? props.defaultLabel : numChecked === 1 ? '1 item' : "".concat(numChecked, " items"));
    if (props.itemOnClick) props.itemOnClick(e);
  };

  // Handle 'click' events on the 'clear' button on the selected toggle.
  var clearHandler = e => {
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        ["".concat(type, "Selection")]: []
      });
    });
    setLabel(props.defaultLabel);
    setSelected(false);
    setKeyPrefix(Date.now());
    if (props.applyOnClick) props.applyOnClick(e);
    if (props.toggleOnClear) props.toggleOnClear(e);
  };
  (0, _react.useEffect)(() => {
    if (!isMounted) return;
    if (searchState["".concat(type, "Selection")].length > 0) {
      updateLabel();
    } else {
      setLabel(props.defaultLabel);
    }
  }, [searchState["".concat(type, "Selection")]]);
  var searchIfFiltersAreUpdated = () => {
    var _searchState$lastFilt, _searchState$lastFilt2;
    if (_.isEqual(searchState === null || searchState === void 0 || (_searchState$lastFilt = searchState.lastFiltersUsed) === null || _searchState$lastFilt === void 0 ? void 0 : _searchState$lastFilt.languageSelection, searchState === null || searchState === void 0 ? void 0 : searchState.languageSelection) && _.isEqual(searchState === null || searchState === void 0 || (_searchState$lastFilt2 = searchState.lastFiltersUsed) === null || _searchState$lastFilt2 === void 0 ? void 0 : _searchState$lastFilt2.specialtySelection, searchState === null || searchState === void 0 ? void 0 : searchState.specialtySelection)) return;else props.applyOnClick();
  };
  var shouldBeDisabled = _.isEqual(searchState["".concat(type, "Selection")], searchState === null || searchState === void 0 || (_searchState$lastFilt3 = searchState.lastFiltersUsed) === null || _searchState$lastFilt3 === void 0 ? void 0 : _searchState$lastFilt3["".concat(type, "Selection")]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown, {
    id: "".concat(type, "-filter-dropdown"),
    className: "dropdown--custom-control checklist-filter-dropdown",
    onToggle: toggleHandler,
    show: showDropdown,
    type: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Toggle, {
    id: "".concat(type, "-filter-dropdown-toggle"),
    label: label,
    onClear: clearHandler,
    selected: selected
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Menu, {
    id: "".concat(type, "-filter-dropdown-menu")
  }, (searchResults === null || searchResults === void 0 ? void 0 : searchResults["".concat(type, "facet")]) && searchResults["".concat(type, "facet")].map((option, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.CheckboxItem, {
      caption: "(".concat(option.doc_count, ")"),
      id: "".concat(type, "-").concat(option.key),
      eventKey: index,
      key: keyPrefix + option.key,
      defaultChecked: searchState["".concat(type, "Selection")].some(e => e.label === option.key),
      checked: true,
      name: option.key,
      onClick: clickHandler
    }, "".concat(option.key));
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.ApplyButton, {
    label: "Apply",
    onClick: applyHandler,
    disabled: shouldBeDisabled
  }))));
}
function ResetFiltersButton(_ref5) {
  var _apiData$data18;
  var {
    setSearchState,
    onSearch,
    apiData
  } = _ref5;
  if ((apiData === null || apiData === void 0 || (_apiData$data18 = apiData.data) === null || _apiData$data18 === void 0 || (_apiData$data18 = _apiData$data18.data) === null || _apiData$data18 === void 0 ? void 0 : _apiData$data18.totalitems) === 0) return null;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-link reset-filter-button",
    onClick: () => {
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          languageSelection: [],
          specialtySelection: []
        });
      });
      onSearch();
    }
  }, "Reset Filters");
}
function Loading() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-filter-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-dots-loading-xl",
    role: "img",
    "aria-label": "MassMutual Logo"
  }));
}
function ViewMapButton(_ref6) {
  var {
    setShowMapPopup
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mm-tablet-mobile-only view-map-button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    className: "btn view-map-button",
    onClick: () => setShowMapPopup(true)
  }, "View the Map"));
}
function Filters(_ref7) {
  var _apiData$data19, _apiData$data20, _apiData$data21, _apiData$data22;
  var {
    searchState,
    setSearchState,
    apiData,
    onSearch,
    showResetFilters,
    setShowMapPopup
  } = _ref7;
  var finproLabel = (apiData === null || apiData === void 0 || (_apiData$data19 = apiData.data) === null || _apiData$data19 === void 0 || (_apiData$data19 = _apiData$data19.data) === null || _apiData$data19 === void 0 ? void 0 : _apiData$data19.totalitems) === 1 ? 'Financial Professional' : 'Financial Professionals';
  var agencyLabel = (apiData === null || apiData === void 0 || (_apiData$data20 = apiData.data) === null || _apiData$data20 === void 0 || (_apiData$data20 = _apiData$data20.data) === null || _apiData$data20 === void 0 ? void 0 : _apiData$data20.totalitems) === 1 ? 'Agency' : 'Agencies';
  var resultsDescription = searchState.finProOrAgencySelection === 'Financial Professional' ? " ".concat(finproLabel, " ").concat(searchState.lastSearchedWasByName ? 'named' : 'near', " \"").concat(searchState.lastSearchedTerm, "\"") : " ".concat(agencyLabel, " ").concat(searchState.lastSearchedWasByName ? 'named' : 'near', " \"").concat(searchState.lastSearchedTerm, "\"");
  var hideDistanceFilter = !!(searchState.lastSearchedWasByName || searchState.hideDistanceFilter);
  var hideChecklistFilters = searchState.finProOrAgencySelection !== 'Financial Professional';
  var hideResetButton = hideChecklistFilters || !showResetFilters;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "full-width-tablet-mobile"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, " ".concat(apiData !== null && apiData !== void 0 && (_apiData$data21 = apiData.data) !== null && _apiData$data21 !== void 0 && (_apiData$data21 = _apiData$data21.data) !== null && _apiData$data21 !== void 0 && _apiData$data21.totalitems ? apiData === null || apiData === void 0 || (_apiData$data22 = apiData.data) === null || _apiData$data22 === void 0 || (_apiData$data22 = _apiData$data22.data) === null || _apiData$data22 === void 0 ? void 0 : _apiData$data22.totalitems : '0', " ")), resultsDescription)), /*#__PURE__*/_react.default.createElement("div", {
    className: "filters"
  }, hideDistanceFilter ? null : /*#__PURE__*/_react.default.createElement(DistanceFilterDropdown, {
    searchState: searchState,
    setSearchState: setSearchState,
    apiData: apiData,
    onSearch: onSearch
  }), hideChecklistFilters ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ChecklistDropdown, {
    searchState: searchState,
    setSearchState: setSearchState,
    applyOnClick: onSearch,
    apiData: apiData,
    defaultLabel: "Languages",
    type: "language"
  }), /*#__PURE__*/_react.default.createElement(ChecklistDropdown, {
    searchState: searchState,
    setSearchState: setSearchState,
    applyOnClick: onSearch,
    apiData: apiData,
    defaultLabel: "Specialties",
    type: "specialty"
  })), hideResetButton ? null : /*#__PURE__*/_react.default.createElement(ResetFiltersButton, {
    setSearchState: setSearchState,
    onSearch: onSearch,
    apiData: apiData
  })), /*#__PURE__*/_react.default.createElement(ViewMapButton, {
    setShowMapPopup: setShowMapPopup
  }));
}
function sendTealiumEvent(searchState, results) {
  var maxWaitTime = 5000; // Maximum wait time in milliseconds
  var checkInterval = 100; // Interval to check for utag availability in milliseconds

  var _waitForUtag = function waitForUtag(resolve, reject) {
    var elapsedTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (window.utag) {
      resolve();
    } else if (elapsedTime >= maxWaitTime) {
      reject(new Error('utag object not available within the maximum wait time'));
    } else {
      setTimeout(() => {
        _waitForUtag(resolve, reject, elapsedTime + checkInterval);
      }, checkInterval);
    }
  };
  return new Promise((resolve, reject) => {
    _waitForUtag(resolve, reject);
  }).then(() => {
    // utag is available, proceed with the function
    if (typeof utag === 'object' && utag.link) {
      var _results$data, _results$data2;
      // create object with filters if appicable, spread them into the link function below
      var filters = '';
      if (searchState.languageSelection.length > 0) {
        searchState.languageSelection.map((language, index) => {
          if (index === 0) {
            filters += "lang:".concat(language.label);
          } else {
            filters += '#' + language.label;
          }
        });
      }
      if (searchState.specialtySelection.length > 0) {
        // add comma if there were previous filters added
        if (filters) filters += ',';
        searchState.specialtySelection.map((specialty, index) => {
          if (index === 0) {
            filters += "focus:".concat(specialty.label);
          } else {
            filters += '#' + specialty.label;
          }
        });
      }
      if (searchState.distanceMiles !== 5) {
        // add comma if there were previous filters added
        if (filters) filters += ',';
        filters += "Distance: ".concat(searchState.distanceMiles);
      }
      // create final data object for link function, spread in filters if applicable
      var utagDataObject = {
        site_id: 'MM-Advisor',
        search_term: searchState.nameOrZipCodeInputSelection,
        search_type: searchState.searchByName ? 'name' : 'location',
        scope: searchState.finProOrAgencySelection === 'Financial Professional' ? 'advisor' : 'agency',
        results_count: results !== null && results !== void 0 && (_results$data = results.data) !== null && _results$data !== void 0 && (_results$data = _results$data.data) !== null && _results$data !== void 0 && _results$data.totalitems ? results === null || results === void 0 || (_results$data2 = results.data) === null || _results$data2 === void 0 || (_results$data2 = _results$data2.data) === null || _results$data2 === void 0 ? void 0 : _results$data2.totalitems.toString() : '0'
      };
      if (filters) {
        utagDataObject.filters = filters;
      }
      utag.view(utagDataObject);
    }
  }).catch(error => {
    // Handle the error or fallback logic here
    console.error(error);
    console.error('Utag object not available within the maximum wait time');
  });
}
var _default = exports.default = FinProSearch;